import { PLAYER_PROMOTION_HISTORY, PROMOTION_END } from '~/utils/api-response/player'
import { PLAYER_PROMOTIONS } from '~/utils/api-response/promotion'

// State
export const state = () => ({
  promotions: [],
  availablePromotions: [],
  promotion: {},
  availablePromotion: {},
  loading: false,
  activePromotion: PLAYER_PROMOTIONS.data[3],
  endPromotion: [],
  rollingReward: {},
  histories: {}
})

// Actions
export const actions = {
  // set promotion
  setPromotion({ commit }, data) {
    commit('setPromotion', data)
  },

  // get promotion in promotion page
  getAvailablePromotions({ commit, rootState }) {
    const response = PLAYER_PROMOTIONS
    commit('setAvailablePromotions', response.data)
  },
  // get promotion
  getPromotions({ commit, rootState }) {
    const promotion = PLAYER_PROMOTIONS
    commit('setPromotions', promotion.data)
  },
  async claimPromotion({ commit }, params) {
    commit('setLoading', true)
    try {
      await this.$axios.post(`/promotions/${params}`)
      return true
    } catch (error) {
      return false
    } finally {
      commit('setLoading', false)
    }
  },
  async activePromotion({ commit }, params) {},
  endPromotion({ commit }, params) {
    const response = PROMOTION_END
    commit('setEndPromotion', response.data)
    return true
  },
  rollingReward({ commit }) {
    return true
  },
  histories({ commit }, params) {
    const response = PLAYER_PROMOTION_HISTORY
    commit('setHistory', response.data)
  },
  claimPromotionCode({ commit, dispatch }, { code, walletPopupStatus }) {
    return false
  },

  checkPromotionWalletPopup({ _ }, id) {
    return false
  }
}

// Mutations
export const mutations = {
  setPromotions: (state, val) => {
    state.promotions = val
  },
  setAvailablePromotions: (state, val) => {
    state.availablePromotions = val
  },
  setAvailablePromotion: (state, val) => {
    state.availablePromotion = val
  },
  setPromotion: (state, val) => {
    state.promotion = val
  },
  setLoading: (state, val) => {
    state.loading = val
  },
  setActivePromotion: (state, val) => {
    state.activePromotion = val
  },
  setEndPromotion: (state, val) => {
    state.endPromotion = val
  },
  setRollingReward: (state, val) => {
    state.rollingReward = val
  },
  setHistory: (state, val) => {
    state.histories = val
  }
}

// Getters
export const getters = {
  promotions: state => {
    return state.promotions.filter(el => el.is_visible === true)
  },
  availablePromotions: state => {
    return state.availablePromotions
  },
  availablePromotion: state => {
    return state.availablePromotion
  },
  promotion: state => {
    return state.promotion
  }
}
